
import Grid7 from "../../../assets/filled/Grid7.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function Grid7Icon({ className, dataTestid = "Grid7Icon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Grid7 data-testid={dataTestid} className={classes} {...rest} />
  );
}
